const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

/**
 * Render a byte count as a short human-readable size (e.g. "1.1 GB", "10.7 MB")
 * Returns undefined for missing or non-positive values so callers can omit the label.
 */
export function formatFileSize(bytes?: number): string | undefined {
    if (bytes == null || !Number.isFinite(bytes) || bytes <= 0) return undefined;
    if (bytes >= GB) return `${(bytes / GB).toFixed(1)} GB`;
    if (bytes >= MB) return `${(bytes / MB).toFixed(1)} MB`;
    if (bytes >= KB) return `${(bytes / KB).toFixed(1)} KB`;
    return `${bytes} B`;
}
